import React, { useState, useEffect } from "react";
import "./createdsr.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notify } from '../../services/notification';
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { PHONE_NUMBER_REGEX, EMAIL_REGEX } from "../../constants/regex/regex";
import { HiMenu, HiX } from "react-icons/hi";
import useMobileView from "../../constants/useMobileView";
import { DsrAction, DsrPincodeAction } from "../../actions/dsrAction";
import { decode } from "base-64";
import Cookies from 'js-cookie';


function CreateDsr() {
    const [loading, setLoading] = useState(false);
    const [pincode, setPicode] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [pincodeLoading, setPincodeLoading] = useState(false);
    const MobileCode = "91";
    const { isSidebarOpen, toggleSidebar } = useMobileView();
    const decodedApsCode = Cookies.get('aps_code') ? decode(Cookies.get('aps_code')) : "";
    const ApsCode = decodedApsCode === "null" ? null : decodedApsCode;

    const navigate = useNavigate();
    const dispatch = useDispatch();


    const [states, setStates] = useState({
        employee_code: "",
        name: "",
        mobile_number: "",
        mobile_code: MobileCode,
        pincode: "",
        email: "",
        city: "",
        district: "",
        state: "",
        aps_code: ApsCode,
    });

    const handleInput = (evt) => {
        let value = evt.target.value.replace(/^ +/gm, "");
        const { name } = evt.target;
        let newState = { ...states };

        if (name === "employee_code") {
            // ensure prefix only once
            if (!value.startsWith("EMP-")) {
                value = `EMP-${value}`;
            }
            newState[name] = value;
        } else if (name === "pincode") {
            if (/^\d{0,6}$/.test(value)) {
                if (newState.pincode.length <= 5 || value.length <= newState.pincode.length)
                    newState.pincode = value;

                // If pincode is 6 digits, fetch location details
                if (value.length === 6) {
                    fetchPincodeDetails(value);
                } else {
                    // Clear location fields if pincode is not 6 digits
                    newState.city = "";
                    newState.district = "";
                    newState.state = "";
                }
            }
        }
        else if (name === "email") {
            newState[name] = value;
            // simple email regex validation
            const emailRegex = EMAIL_REGEX;
            if (value && !emailRegex.test(value)) {
                setEmailError("Please enter a valid email address.");
            } else {
                setEmailError("");
            }
        }
        else {
            newState[name] = value;
        }
        setStates(newState);
    };
    const isValidName = (name) => {
        const match = name.match(/[A-Za-z]/g); // find all alphabetic characters
        return match && match.length >= 3;
    };
    const validatePhoneNumber = (value) => {
        if (value === "" || PHONE_NUMBER_REGEX.test(value)) {
            setStates((prevState) => ({
                ...prevState,
                mobile_number: value.replace(/^ +/gm, ""),
            }));
        }
    };
    const fetchPincodeDetails = async (pincodeValue) => {
        setPincodeLoading(true);
        try {
            const response = await dispatch(DsrPincodeAction(pincodeValue));
            if (response?.status === 200 && response?.data?.data) {
                if (response?.data?.data?.length == 0) {
                    notify.error("No Record Found")
                    return;
                }
                const locationData = response?.data?.data?.[0];
                setStates(prevState => ({
                    ...prevState,
                    city: locationData?.city || "",
                    district: locationData?.district || "",
                    state: locationData?.state || "",
                }));
            }
            else {
                // Clear fields if no data found
                setStates(prevState => ({
                    ...prevState,
                    city: "",
                    district: "",
                    state: "",
                }));
            }
        } catch (error) {
            console.error('Error fetching pincode details:', error);
            notify.error('Failed to fetch location details');
            // Clear fields on error
            setStates(prevState => ({
                ...prevState,
                city: "",
                district: "",
                state: "",
            }));
        } finally {
            setPincodeLoading(false);
        }
    };

    const handleOnSaveClick = async (e) => {
        e.preventDefault();
        if (!isValidName(states.name)) {
            notify.error("Name must contain at least three alphabetic characters.");
            return;
        }
        if (states.mobile_number?.length !== 10 || !PHONE_NUMBER_REGEX?.test(states.mobile_number)) {
            notify.error("Phone number must be exactly 10 digits and start with 6, 7, 8, or 9.");
            return;
        }
        setLoading(true);
        try {
            // match payload
            const payload = {
                employee_code: states.employee_code,
                name: states.name,
                mobile_code: states.mobile_code,
                mobile_number: states.mobile_number,
                email: states.email,
                // pincode: states.pincode,
                // city: states.city,
                // district: states.district,
                // state: states.state,
                // aps_code: states.aps_code,
            };

            const response = await dispatch(DsrAction(payload));
            if (response?.status === 200 || response?.status === 201) {
                notify.success('DSR created Successfully');
                setLoading(false);
                navigate("/dsr");
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    return (
        <div className="create-dsr-container" style={{ marginTop: "10 rem" }}>
            <div className="create-dsr-containerright">
                <Header title="Create DSR" />
                <>
                    {loading ? (
                        <Loader />
                    ) : (
                        <div className="form-div" style={{ marginLeft: "10 rem" }}>
                            {/* Name */}
                            <div className="grid">
                                <label className="label-create-dsr">Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Enter Full Name"
                                    value={states.name}
                                    onChange={handleInput}
                                    className="create-dsr-input-field"
                                    required
                                />
                            </div>

                            {/* Employee Code */}
                            <div className="grid">
                                <label className="label-create-dsr">Employee Code</label>
                                <input
                                    type="text"
                                    name="employee_code"
                                    placeholder="Enter Employee Code"
                                    value={states.employee_code}
                                    onChange={handleInput}
                                    onFocus={() => {
                                        if (!states.employee_code.startsWith("EMP-")) {
                                            setStates({ ...states, employee_code: "EMP-" });
                                        }
                                    }}
                                    className="create-dsr-input-field"
                                    required
                                />
                            </div>

                            {/* Phone Number */}
                            <div className="grid">
                                <label className="label-create-dsr">Phone Number</label>
                                <div>
                                    <input
                                        type="text"
                                        name="mobile_number"
                                        placeholder="Enter Phone Number"
                                        value={states.mobile_number}
                                        minLength={10}
                                        title="Phone number must start with 6-9 and be 10 digits"
                                        maxLength={10}
                                        onChange={(e) => validatePhoneNumber(e.target.value)}
                                        className="create-dsr-input-field"
                                    />
                                    {states.mobile_number && states.mobile_number.length !== 10 && (
                                        <span className="error-message">
                                            Phone number must be exactly 10 digits.
                                        </span>
                                    )}
                                </div>
                            </div>

                            {/* Pincode */}
                            {/* <div className="grid">
                                <label className="label-create-dsr">Pincode</label>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        name="pincode"
                                        placeholder="Enter Pincode"
                                        value={states.pincode}
                                        onChange={handleInput}
                                        className="create-dsr-input-field"
                                    />
                                    {pincodeLoading && (
                                        <span style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            fontSize: '12px',
                                            color: '#666'
                                        }}>
                                            Loading...
                                        </span>
                                    )}
                                </div>
                            </div> */}

                            {/* City */}
                            {/* <div className="grid">
                                <label className="label-create-dsr-non-mandatory">City</label>
                                <input
                                    type="text"
                                    name="city"
                                    placeholder="Enter City"
                                    value={states.city}
                                    onChange={handleInput}
                                    className="create-dsr-input-field"
                                    readOnly
                                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                />
                            </div> */}

                            {/* District */}
                            {/* <div className="grid">
                                <label className="label-create-dsr-non-mandatory">District</label>
                                <input
                                    type="text"
                                    name="district"
                                    placeholder="Enter District"
                                    value={states.district}
                                    onChange={handleInput}
                                    className="create-dsr-input-field"
                                    readOnly
                                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                />
                            </div> */}

                            {/* State */}
                            {/* <div className="grid">
                                <label className="label-create-dsr-non-mandatory">State</label>
                                <input
                                    type="text"
                                    name="state"
                                    placeholder="Enter State"
                                    value={states.state}
                                    onChange={handleInput}
                                    className="create-dsr-input-field"
                                    readOnly
                                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                />
                            </div> */}

                            {/* Aps Code */}
                            <div className="grid">
                                <label className="label-create-dsr">Aps Code</label>
                                <input
                                    type="text"
                                    name="aps_code"
                                    placeholder="Enter Aps Code"
                                    value={states.aps_code || ""}
                                    onChange={handleInput}
                                    className="create-dsr-input-field"
                                    readOnly={states.aps_code && states.aps_code.trim() !== null && states.aps_code?.length >= 5}
                                    style={(states.aps_code && states.aps_code.trim() !== null && states.aps_code?.length >= 5) ? { backgroundColor: '#f5f5f5', cursor: 'not-allowed' } : {}}
                                />
                            </div>

                            {/* Email */}
                            <div className="grid">
                                <label className="label-create-dsr-non-mandatory">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Enter Email"
                                    value={states.email}
                                    onChange={handleInput}
                                    className="create-dsr-input-field"
                                />
                            </div>
                            {emailError && (
                                <span className="error-message-email">{emailError}</span>
                            )}

                            {/* Buttons */}
                            <div className="btn-notify">
                                <button
                                    onClick={() => navigate("/dsr")}
                                    className="dsr-active"
                                    type="submit"
                                >
                                    Close
                                </button>
                                <button
                                    className="dsr-active"
                                    type="submit"
                                    disabled={!states.name ||
                                        !states.employee_code ||
                                        !states.mobile_number
                                        // states.employee_code?.length < 5 ||
                                        // !(states.pincode.length == 6)
                                    }
                                    onClick={handleOnSaveClick}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    )}
                </>
            </div>
        </div>
    );
}

export default CreateDsr;